import { createFileRoute } from '@tanstack/react-router'
import { Globe2 } from 'lucide-react'
import { ResidencyScreen } from '@/screens/govern/SCR-050-residency'

export const Route = createFileRoute('/_app/govern/residency')({
  staticData: { screen: { id: 'SCR-050', title: 'Residency & keys', group: 'Govern', perm: 'deployment.manage', order: 4, description: 'Where your data lives, which providers may touch it, and your keys.', icon: Globe2 } },
  component: ResidencyScreen,
})
